module.exports = __webpack_public_path__ + "img/diesel-logbook-example.eab63422.png";